import * as  _ from 'lodash';
import { DEFAULT_INTERIM_MESSAGE } from '../../../../../alan_btn/src/textChat/helpers/getMsgLoader';

const BTN_TIMEOUT = 10; // in secs

const defaultBtnOptions = require('../../../../alanBtnJsonSettings/default.json');

export const DEFAULT_ALAN_BTN_SIZE = 64;

export const TIMEOUT_OPT_KEY = 'timeout';

export const WAKE_WORD_ENABLED_OPT_KEY = 'alanWakeWord.wakeWordEnabled';
export const WAKE_WORD_ENABLED_OPT_KEY_OLD = 'wakeWordEnabled';

export const WAKE_WORD_IN_BACKGROUND_OPT_KEY = 'alanWakeWord.wakeWordInBackground';
export const WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD = 'wakeWordInBackground';

export const WAKE_WORD_PATH_OPT_KEY = 'alanWakeWord.wakeWordPath';
export const WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY = 'alanWakeWord.wakeWordModel3.modelUrl';

export const KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL = 'Keep active while the app is in the background';
export const WAKE_WORD_IN_BACKGROUND_OPT_LABEL = 'Use wake word in background';
export const WAKE_WORD_ENABLED_OPT_LABEL = 'Enable wake word';
export const QRCODE_ENABLED_OPT_LABEL = 'Enable QR Code reader';

export const ALAN_EXTENSION_ALLOWED_SITES_OPT_KEY = 'alanExtension.allowedSites';
export const ALAN_EXTENSION_BTN_OPTIONS_OPT_KEY = 'alanExtension.btnOptions';


export const TEXT_CHAT_ENABLED_KEY = 'chatOptions.textChat.enabled';
export const TEXT_CHAT_VOICE_ENABLED_KEY = 'chatOptions.textChat.voice.enabled';
export const TEXT_CHAT_AUDIO_ENABLED_KEY = 'chatOptions.textChat.audio.enabled';
export const TEXT_CHAT_AUDIO_VISIBLE_KEY = 'chatOptions.textChat.audio.visible';
export const TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY = 'chatOptions.textChat.popup.gradientType';
export const TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY = 'chatOptions.textChat.popup.background.customCss';
export const TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.popup.backgroundColor';
export const TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY = 'chatOptions.textChat.popup.backgroundColor2';
export const TEXT_CHAT_POPUP_HAS_BORDER_KEY = 'chatOptions.textChat.popup.hasBorder';
export const TEXT_CHAT_POPUP_BORDER_COLOR_KEY = 'chatOptions.textChat.popup.borderColor';
export const TEXT_CHAT_POPUP_OPEN_BY_DEFAULT_KEY = 'chatOptions.textChat.popup.openByDefualt';
export const TEXT_CHAT_POPUP_CLEAR_CHAT_ON_CLOSE_KEY = 'chatOptions.textChat.popup.clearChatOnClose';
export const TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY = 'chatOptions.textChat.popup.fullScreenMode.enabled';
export const TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY = 'chatOptions.textChat.popup.minimizeMode.enabled';
export const TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY = 'chatOptions.textChat.popup.saveChatState.enabled';
export const TEXT_CHAT_POPUP_MIN_HEIGHT_KEY = 'chatOptions.textChat.popup.minHeight';
export const TEXT_CHAT_POPUP_MAX_HEIGHT_KEY = 'chatOptions.textChat.popup.maxHeight';
export const TEXT_CHAT_POPUP_HEIGHT_KEY = 'chatOptions.textChat.popup.height';
export const TEXT_CHAT_POPUP_MIN_WIDTH_KEY = 'chatOptions.textChat.popup.minWidth';
export const TEXT_CHAT_POPUP_MAX_WIDTH_KEY = 'chatOptions.textChat.popup.maxWidth';
export const TEXT_CHAT_POPUP_WIDTH_KEY = 'chatOptions.textChat.popup.width';
export const TEXT_CHAT_POPUP_FONT_FAMILY_KEY = 'chatOptions.textChat.popup.fontFamily';

export const TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.popup.borderRadius.topLeft';
export const TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.popup.borderRadius.topRight';
export const TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.popup.borderRadius.bottomLeft';
export const TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.popup.borderRadius.bottomRight';
export const TEXT_CHAT_POPUP_HAS_SHADOW_KEY = 'chatOptions.textChat.popup.hasShadow';

export const TEXT_CHAT_POPUP_PADDING_TOP_KEY = 'chatOptions.textChat.popup.padding.top';
export const TEXT_CHAT_POPUP_PADDING_RIGHT_KEY = 'chatOptions.textChat.popup.padding.right';
export const TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY = 'chatOptions.textChat.popup.padding.bottom';
export const TEXT_CHAT_POPUP_PADDING_LEFT_KEY = 'chatOptions.textChat.popup.padding.left';

export const TEXT_CHAT_HEADER_LAYOUT_NAME_KEY = 'chatOptions.textChat.header.layout.name';
export const TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.header.backgroundColor';
export const TEXT_CHAT_HEADER_FONT_SIZE_KEY = 'chatOptions.textChat.header.fontSize';
export const TEXT_CHAT_HEADER_FONT_COLOR_KEY = 'chatOptions.textChat.header.color';
export const TEXT_CHAT_HEADER_LABEL_KEY = 'chatOptions.textChat.header.label';
export const TEXT_CHAT_HEADER_LABEL_ICON_KEY = 'chatOptions.textChat.header.icon.svg';
export const TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY = 'chatOptions.textChat.header.icon.gap';
export const TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY = 'chatOptions.textChat.header.alignment';
export const TEXT_CHAT_HEADER_HEIGHT_KEY = 'chatOptions.textChat.header.height';
export const TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY = 'chatOptions.textChat.header.withBottomGradient';
export const TEXT_CHAT_HEADER_PADDING_TOP_KEY = 'chatOptions.textChat.header.padding.top';
export const TEXT_CHAT_HEADER_PADDING_RIGHT_KEY = 'chatOptions.textChat.header.padding.right';
export const TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY = 'chatOptions.textChat.header.padding.bottom';
export const TEXT_CHAT_HEADER_PADDING_LEFT_KEY = 'chatOptions.textChat.header.padding.left';

export const TEXT_CHAT_FOOTER_HEIGHT_KEY = 'chatOptions.textChat.footer.height';
export const TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY = 'chatOptions.textChat.footer.withTopGradient';
export const TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.footer.backgroundColor';
export const TEXT_CHAT_FOOTER_PADDING_TOP_KEY = 'chatOptions.textChat.footer.padding.top';
export const TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY = 'chatOptions.textChat.footer.padding.right';
export const TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY = 'chatOptions.textChat.footer.padding.bottom';
export const TEXT_CHAT_FOOTER_PADDING_LEFT_KEY = 'chatOptions.textChat.footer.padding.left';
export const TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY = 'chatOptions.textChat.footer.layout.name';

export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY = 'chatOptions.textChat.bubbles.waitingResponse.layout';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY = 'chatOptions.textChat.bubbles.waitingResponse.label';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY = 'chatOptions.textChat.bubbles.waitingResponse.queryProgress.enabled';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY = 'chatOptions.textChat.bubbles.waitingResponse.icon.svg';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY = 'chatOptions.textChat.bubbles.waitingResponse.icon.default.fill';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.bubbles.waitingResponse.icon.hover.fill';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY = 'chatOptions.textChat.bubbles.waitingResponse.icon.gap';
export const TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY = 'chatOptions.textChat.bubbles.waitingResponse.alignment';

export const TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY = 'chatOptions.textChat.bubbles.newDialog.separator.color';

export const TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.backgroundColor';
export const TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.response.color';
export const TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY = 'chatOptions.textChat.bubbles.response.fontSize';
export const TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY = 'chatOptions.textChat.bubbles.response.copyBtn';
export const TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY = 'chatOptions.textChat.bubbles.response.likeBtn';

export const TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY = 'chatOptions.textChat.bubbles.response.bottomBtns.color';
export const TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY = 'chatOptions.textChat.bubbles.response.bottomBtns.backgroundColor.hover';

export const TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.request.backgroundColor';
export const TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.request.color';
export const TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY = 'chatOptions.textChat.bubbles.request.fontSize';
export const TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY = 'chatOptions.textChat.bubbles.request.padding.top';
export const TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY = 'chatOptions.textChat.bubbles.request.padding.right';
export const TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY = 'chatOptions.textChat.bubbles.request.padding.bottom';
export const TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY = 'chatOptions.textChat.bubbles.request.padding.left';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY = 'chatOptions.textChat.bubbles.request.label.text';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY = 'chatOptions.textChat.bubbles.request.label.fontSize';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.request.label.color';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY = 'chatOptions.textChat.bubbles.request.label.enabled';

export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY = 'chatOptions.textChat.bubbles.request.label.padding.top';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY = 'chatOptions.textChat.bubbles.request.label.padding.right';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY = 'chatOptions.textChat.bubbles.request.label.padding.bottom';
export const TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY = 'chatOptions.textChat.bubbles.request.label.padding.left';

export const TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY = 'chatOptions.textChat.bubbles.response.padding.top';
export const TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.padding.right';
export const TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY = 'chatOptions.textChat.bubbles.response.padding.bottom';
export const TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY = 'chatOptions.textChat.bubbles.response.padding.left';

export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY = 'chatOptions.textChat.bubbles.response.label.text';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY = 'chatOptions.textChat.bubbles.response.label.fontSize';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.response.label.color';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY = 'chatOptions.textChat.bubbles.response.label.enabled';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY = 'chatOptions.textChat.bubbles.response.label.icon.svg';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY = 'chatOptions.textChat.bubbles.response.label.icon.gap';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY = 'chatOptions.textChat.bubbles.response.label.alignment';

export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY = 'chatOptions.textChat.bubbles.response.label.padding.top';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.label.padding.right';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY = 'chatOptions.textChat.bubbles.response.label.padding.bottom';
export const TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY = 'chatOptions.textChat.bubbles.response.label.padding.left';

export const TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY = 'chatOptions.textChat.textarea.fieldType';
export const TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY = 'chatOptions.textChat.textarea.maxLinesCount';
export const TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY = 'chatOptions.textChat.textarea.fontSize';
export const TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY = 'chatOptions.textChat.textarea.placeholder';
export const TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY = 'chatOptions.textChat.textarea.color';
export const TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY = 'chatOptions.textChat.textarea.placeholderColor';
export const TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.textarea.backgroundColor';
export const TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.general.default.fill';
export const TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.general.hover.fill';
export const TEXT_CHAT_MUTE_ICON_KEY = 'chatOptions.textChat.popup.icons.mute.svgOff';
export const TEXT_CHAT_UNMUTE_ICON_KEY = 'chatOptions.textChat.popup.icons.mute.svgOn';
export const TEXT_CHAT_CLOSE_ICON_KEY = 'chatOptions.textChat.popup.icons.close.svg';
export const TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY = 'chatOptions.textChat.popup.icons.saveChatState.svg';
export const TEXT_CHAT_SEND_ICON_KEY = 'chatOptions.textChat.popup.icons.send.svg';
export const TEXT_CHAT_MIC_ICON_KEY = 'chatOptions.textChat.popup.icons.mic.svg';
export const TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.close.default.fill';
export const TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.close.hover.fill';

export const TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.minimize.default.fill';
export const TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.minimize.hover.fill';
export const TEXT_CHAT_MINIMIZE_ICON_KEY = 'chatOptions.textChat.popup.icons.minimize.svg';

export const TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.clear.default.fill';
export const TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.clear.hover.fill';
export const TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY = 'chatOptions.textChat.popup.icons.clear.visible';
export const TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.mute.default.fill';
export const TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.mute.hover.fill';
export const TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.fullScreen.default.fill';
export const TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY = 'chatOptions.textChat.popup.icons.fullScreen.svgExpand';
export const TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY = 'chatOptions.textChat.popup.icons.fullScreen.svgCollapse';
export const TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.fullScreen.hover.fill';

export const TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.saveChatState.default.fill';
export const TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.saveChatState.hover.fill';

export const TEXT_CHAT_SIDE_BAR_ICON_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.sideBar.default.fill';
export const TEXT_CHAT_SIDE_BAR_ICON_HOVER_FILL_COLOR_KEY = 'chatOptions.textChat.popup.icons.sideBar.hover.fill';
export const TEXT_CHAT_NOTIFICATIONS_BUBBLE_ENABLED_KEY = 'chatOptions.textChat.notifications.enabled';
export const TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.notifications.backgroundColor';
export const TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY = 'chatOptions.textChat.notifications.color';
export const TEXT_CHAT_ALAN_BTN_BG_KEY = 'btnOptions.textChat.background.color';
export const TEXT_CHAT_ALAN_BTN_LOGO_KEY = 'logoTextChat';
export const ALAN_BTN_SIZE_KEY = 'buttonSize';
export const PAGE_STATE_AUTO_SYNC_ENABLED_KEY = 'pageState.autoSync';

export const TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.bubbles.request.borderRadius.topLeft';
export const TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.bubbles.request.borderRadius.topRight';
export const TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.bubbles.request.borderRadius.bottomLeft';
export const TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.bubbles.request.borderRadius.bottomRight';
export const TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.request.borderColor';
export const TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY = 'chatOptions.textChat.bubbles.request.hasShadow';

export const TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.bubbles.response.borderRadius.topLeft';
export const TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.borderRadius.topRight';
export const TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.bubbles.response.borderRadius.bottomLeft';
export const TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.borderRadius.bottomRight';
export const TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.borderColor';

export const TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.codeBackgroundColor';
export const TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.codeBorderColor';
export const TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY = 'chatOptions.textChat.bubbles.response.codeTheme';

export const TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY = 'chatOptions.textChat.bubbles.response.hasShadow';
export const TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.response.links.color.default';
export const TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY = 'chatOptions.textChat.bubbles.response.links.color.hover';

export const TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.textarea.borderRadius.topLeft';
export const TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.textarea.borderRadius.topRight';
export const TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.textarea.borderRadius.bottomLeft';
export const TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.textarea.borderRadius.bottomRight';

export const TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY = 'chatOptions.textChat.textarea.padding.top';
export const TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY = 'chatOptions.textChat.textarea.padding.right';
export const TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY = 'chatOptions.textChat.textarea.padding.bottom';
export const TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY = 'chatOptions.textChat.textarea.padding.left';


export const TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY = 'chatOptions.textChat.textarea.borderColor';
export const TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY = 'chatOptions.textChat.textarea.hasShadow';

export const TEXT_CHAT_BUTTONS_FONT_SIZE_KEY = 'chatOptions.textChat.buttons.fontSize';
export const TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.buttons.borderRadius.topLeft';
export const TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.buttons.borderRadius.topRight';
export const TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.buttons.borderRadius.bottomLeft';
export const TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.buttons.borderRadius.bottomRight';

export const TEXT_CHAT_BUTTONS_PADDING_TOP_KEY = 'chatOptions.textChat.buttons.padding.top';
export const TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY = 'chatOptions.textChat.buttons.padding.right';
export const TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY = 'chatOptions.textChat.buttons.padding.bottom';
export const TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY = 'chatOptions.textChat.buttons.padding.left';

export const TEXT_CHAT_BUTTONS_FONT_COLOR_KEY = 'chatOptions.textChat.buttons.default.color';
export const TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.buttons.default.backgroundColor';
export const TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY = 'chatOptions.textChat.buttons.default.borderColor';
export const TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY = 'chatOptions.textChat.buttons.default.hasShadow';

export const TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY = 'chatOptions.textChat.buttons.hover.color';
export const TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY = 'chatOptions.textChat.buttons.hover.backgroundColor';
export const TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY = 'chatOptions.textChat.buttons.hover.borderColor';
export const TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY = 'chatOptions.textChat.buttons.hover.hasShadow';

export const TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY = 'chatOptions.textChat.buttons.active.color';
export const TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY = 'chatOptions.textChat.buttons.active.backgroundColor';
export const TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY = 'chatOptions.textChat.buttons.active.borderColor';
export const TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY = 'chatOptions.textChat.buttons.active.hasShadow';

export const TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY = 'chatOptions.textChat.buttons.alignment.default';
export const TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY = 'chatOptions.textChat.buttons.alignment.fullScreen';
export const TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY = 'chatOptions.textChat.buttons.textAlign.default';
export const TEXT_CHAT_BUTTONS_GAP_KEY = 'chatOptions.textChat.buttons.gap';

export const TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.table.borderColor';


export const TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.default.borderColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.hover.borderColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.active.borderColor';

export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.default.linkNumberBackgroundColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.hover.linkNumberBackgroundColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.active.linkNumberBackgroundColor';

export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.default.backgroundColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.hover.backgroundColor';
export const TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.active.backgroundColor';

export const TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.borderRadius.topLeft';
export const TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.borderRadius.topRight';
export const TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.borderRadius.bottomLeft';
export const TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY = 'chatOptions.textChat.bubbles.response.learnMore.links.borderRadius.bottomRight';


export const QRCODE_ENABLED_OPT_KEY = 'qrCode.enabled';

export const TEXT_CHAT_DEFAULT_HEIGHT = '700';

interface IIcon {
    default: {
        fill: string
    },
    hover: {
        fill: string
    },
}

interface IIconWithGap {
    svg: string,
    gap: string
}
interface IClearIcon extends IIconWithCustomSvg {
    visible: boolean
}

interface IIconWithCustomSvg extends IIcon {
    svg?: string
}

interface IIconFillScreenMode extends IIcon {
    svgExpand?: string
    svgCollapse?: string
}

interface IMuteIcon extends IIcon {
    svgOn?: string
    svgOff?: string
}

interface IBorderRadius {
    topLeft: string,
    topRight: string,
    bottomRight: string,
    bottomLeft: string,
}

interface IPadding {
    top: string,
    right: string,
    bottom: string,
    left: string,
}

interface ILayout {
    name: string;
}

interface IAlanButtonOptions {
    hidden: boolean,
    keepMicrophoneInBackground: boolean,
    timeout: number,
    hideS2TPanel: boolean,
    screenshotEnabled: boolean,
    recordAudioEnabled: boolean,
    playReadyToListenSound: boolean,
    buttonSize: number,
    wakeWordInBackground: boolean,
    wakeWordEnabled: boolean,
    pageState: {
        autoSync: boolean
    },
    qrCode: {
        enabled: boolean,
    },
    alanWakeWord: {
        wakeWordEnabled: boolean,
        wakeWordInBackground: boolean,
        wakeWordPath: string
        selectedWakeWordId: string
        wakeWordModel: object
    },

    alanExtension: {
        allowedSites: string,
        btnOptions: string
    }

    keepButtonPositionAfterDnD: boolean,
    alanButtonDragAndDrop: {
        keepButtonPositionAfterDnD: boolean
        dragAndDropEnabled: boolean
    },

    popupEnabled: boolean,
    debugChatEnabled: boolean,
    alanButtonPopup: {
        popupEnabled: boolean,
        debugChatEnabled: boolean,
    },
    chatOptions: {
        textChat: {
            enabled: boolean,
            voice: {
                enabled: boolean,
            },
            audio: {
                enabled: boolean,
                visible: boolean
            },
            popup: {
                backgroundColor: string,
                backgroundColor2: string,
                gradientType: string,
                background: {
                    customCss: string
                }
                borderColor: string,
                hasBorder: boolean,
                openByDefualt: boolean,
                clearChatOnClose: boolean,
                saveChatState: {
                    enabled: boolean
                },
                fullScreenMode: {
                    enabled: boolean
                },
                minimizeMode: {
                    enabled: boolean
                },
                icons: {
                    close: IIconWithCustomSvg,
                    minimize: IIconWithCustomSvg,
                    clear: IClearIcon,
                    mute: IMuteIcon,
                    general: IIcon,
                    send: IIcon,
                    mic: IIcon,
                    fullScreen: IIconFillScreenMode,
                    sideBar: IIcon,
                    saveChatState: IIconWithCustomSvg,
                },
                minHeight: string,
                height: string,
                maxHeight: string,
                minWidth: string,
                width: string,
                maxWidth: string,
                fontFamily: string,
                borderRadius: IBorderRadius
                padding: IPadding
            },
            header: {
                layout: ILayout,
                icon: IIconWithGap,
                backgroundColor: string,
                fontSize: string,
                label: string
                color: string,
                height: string,
                withBottomGradient: boolean,
                padding: IPadding,
                alignment: string,
            },
            footer: {
                height: string,
                withTopGradient: boolean,
                backgroundColor: string,
                padding: IPadding,
                layout: ILayout
            },
            textarea: {
                fieldType: string,
                maxLinesCount: number,
                fontSize: string,
                placeholder: string,
                backgroundColor: string,
                color: string,
                placeholderColor: string,
                borderRadius: IBorderRadius,
                borderColor: string,
                hasShadow: boolean,
                padding: IPadding
            },
            bubbles: {
                request: {
                    label: {
                        enabled: boolean,
                        text: string,
                        padding: IPadding
                    },
                    backgroundColor: string,
                    fontSize: string
                    color: string,
                    borderRadius: IBorderRadius,
                    borderColor: string,
                    hasShadow: boolean,
                    padding: IPadding
                },
                response: {
                    label: {
                        enabled: boolean,
                        text: string,
                        padding: IPadding
                        icon: IIconWithGap,
                        alignment: string,
                    },
                    backgroundColor: string,
                    codeBackgroundColor: string,
                    codeTheme: string,
                    codeBorderColor: string,
                    fontSize: string
                    color: string,
                    copyBtn: boolean,
                    likeBtn: boolean,
                    bottomBtns: {
                        color: string,
                        backgroundColor: {
                            hover: string
                        },
                    },
                    borderRadius: IBorderRadius,
                    borderColor: string,
                    hasShadow: boolean,
                    table: {
                        borderColor: string,
                    },
                    links: {
                        color: {
                            default: string,
                            hover: string,
                            disable: string,
                        }
                    },
                    learnMore: {
                        links: {
                            // gap: string,
                            borderRadius: IBorderRadius,
                            // padding: IPadding,
                            default: {
                                linkNumberBackgroundColor: string,
                                backgroundColor: string,
                                color: string,
                                borderColor: string,
                            },
                            hover: {
                                linkNumberBackgroundColor: string,
                                backgroundColor: string,
                                color: string,
                                borderColor: string,
                            },
                            active: {
                                linkNumberBackgroundColor: string,
                                backgroundColor: string,
                                color: string,
                                borderColor: string,
                            },
                        }
                    },
                    padding: IPadding
                },
                waitingResponse: {
                    queryProgress: {
                        enabled: boolean
                    },
                    alignment: string,
                    layout: string,
                    label: string,
                    icon: {
                        svg: string,
                        gap: string,
                        default: {
                            fill: string,
                        },
                        hover: {
                            fill: string,
                        },
                    },
                },
                newDialog: {
                    separator: {
                        color: string
                    }
                }
            },
            notifications: {
                enabled: boolean,
                backgroundColor: string,
                color: string

            },
            buttons: {
                gap: string,
                fontSize: string,
                borderRadius: IBorderRadius,
                padding: IPadding,
                default: {
                    backgroundColor: string,
                    color: string,
                    borderColor: string,
                    hasShadow: boolean
                },
                hover: {
                    backgroundColor: string,
                    color: string,
                    borderColor: string,
                    hasShadow: boolean
                },
                active: {
                    backgroundColor: string,
                    color: string,
                    borderColor: string,
                    hasShadow: boolean
                },
                alignment: {
                    default: string,
                    fullScreen: string
                },
                textAlign: {
                    default: string,
                    fullScreen: string
                },
            },
        }
    }
}

export function getDefaultOptionsValue(platform: string, optionName: string) {
    const redefinedValue = _.get(REDEFINED_OPTIONS_VALUES[platform], optionName);
    if (redefinedValue) {
        return redefinedValue;
    }
    return _.get(DEFAULT_OPTIONS_VALUES, optionName);
}

const REDEFINED_OPTIONS_VALUES = {
    ios: {
        chatOptions: {
            textChat: {
                header: {
                    fontSize: '16',
                },
                textarea: {
                    fontSize: '18',
                },
                bubbles: {
                    request: {
                        fontSize: '16'
                    },
                    response: {
                        fontSize: '16'
                    }
                }
            }
        }
    }
};

export function getDefaultOptions() {
    return { ...DEFAULT_OPTIONS_VALUES };
}


// Here are some options are duplicated because we have to support new and old format of the options
const DEFAULT_OPTIONS_VALUES = {
    hidden: false,
    keepMicrophoneInBackground: false,
    timeout: BTN_TIMEOUT,
    hideS2TPanel: false,
    screenshotEnabled: false,
    recordAudioEnabled: false,
    playReadyToListenSound: true,
    btnOptions: defaultBtnOptions,
    wakeWordInBackground: false,
    wakeWordEnabled: false,
    buttonSize: DEFAULT_ALAN_BTN_SIZE,
    pageState: {
        autoSync: true
    },
    qrCode: {
        enabled: true,
    },
    alanWakeWord: {
        wakeWordEnabled: false,
        wakeWordInBackground: false,
        wakeWordPath: "",
        selectedWakeWordId: "",
        wakeWordModel: {}
    },

    alanExtension: {
        allowedSites: '',
        btnOptions: '{}'
    },

    keepButtonPositionAfterDnD: false,
    alanButtonDragAndDrop: {
        keepButtonPositionAfterDnD: false,
        dragAndDropEnabled: true
    },

    popupEnabled: true,
    debugChatEnabled: false,
    alanButtonPopup: {
        popupEnabled: true,
        debugChatEnabled: false,
    },
    chatOptions: {
        textChat: {
            enabled: true,
            voice: {
                enabled: false,
            },
            audio: {
                enabled: false,
                visible: true
            },
            popup: {
                backgroundColor: '#DAEBFF',
                backgroundColor2: '#ffffff',
                gradientType: 'linear',
                background: {
                    customCss: null
                },
                borderColor: '#ffffff',
                hasBorder: false,
                openByDefualt: false,
                clearChatOnClose: false,
                saveChatState: {
                    enabled: false
                },
                fullScreenMode: {
                    enabled: false
                },
                minimizeMode: {
                    enabled: false
                },
                icons: {
                    close: {
                        svg: null,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#97989c'
                        },
                    },
                    minimize: {
                        svg: null,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#97989c'
                        },
                    },
                    clear: {
                        svg: null,
                        visible: true,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#0046ff'
                        },
                    },
                    send: {
                        svg: null,
                        default: {
                            fill: '#171717'
                        },
                        hover: {
                            fill: '#0078ff'
                        },
                    },
                    mic: {
                        svg: null,
                        default: {
                            fill: '#171717'
                        },
                        hover: {
                            fill: '#0078ff'
                        },
                    },
                    mute: {
                        svgOn: null,
                        svgOff: null,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#0046ff'
                        },
                    },
                    fullScreen: {
                        svgExpand: null,
                        svgCollapse: null,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#0046ff'
                        },
                    },
                    saveChatState: {
                        svg: null,
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#0046ff'
                        },
                    },
                    sideBar: {
                        default: {
                            fill: '#969EB0'
                        },
                        hover: {
                            fill: '#0046ff'
                        },
                    },
                    general: {
                        default: {
                            fill: '#171717'
                        },
                        hover: {
                            fill: '#0078ff'
                        },
                    }
                },
                minHeight: '400',
                height: TEXT_CHAT_DEFAULT_HEIGHT,
                maxHeight: '1200',
                minWidth: '250',
                width: '400',
                maxWidth: '1200',
                fontFamily: 'Poppins',
                borderRadius: {
                    topLeft: '20',
                    topRight: '20',
                    bottomRight: '20',
                    bottomLeft: '20',
                },
                padding: {
                    top: '20',
                    right: '15',
                    bottom: '20',
                    left: '15',
                }
            },
            header: {
                layout: {
                    name: 'centered-title'
                },
                icon: {
                    svg: null,
                    gap: '12'
                },
                color: '#000000',
                backgroundColor: '#ffffff',
                fontSize: '16',
                label: 'Alan AI Assistant',
                height: '40',
                withBottomGradient: true,
                padding: {
                    top: '12',
                    right: '11',
                    bottom: '0',
                    left: '11',
                },
                alignment: 'center'
            },
            footer: {
                height: '67',
                withTopGradient: true,
                backgroundColor: '#DAEBFF',
                padding: {
                    top: '2',
                    right: '18',
                    bottom: '15',
                    left: '18',
                },
                layout: { name: 'default' }
            },
            textarea: {
                fieldType: 'single-line',
                maxLinesCount: 7,
                fontSize: '15',
                placeholder: 'Ask me anything...',
                backgroundColor: '#ffffff',
                color: '#171717',
                placeholderColor: '#747474',
                borderRadius: {
                    topLeft: '20',
                    topRight: '20',
                    bottomRight: '20',
                    bottomLeft: '20',
                },
                padding: {
                    top: '12',
                    right: '42',
                    bottom: '12',
                    left: '12',
                },
                borderColor: '#ffffff',
                hasShadow: true
            },
            bubbles: {
                request: {
                    label: {
                        enabled: false,
                        text: 'Me',
                        color: '#171717',
                        fontSize: '15',
                        padding: {
                            top: '0',
                            right: '0',
                            bottom: '4',
                            left: '0',
                        }
                    },
                    backgroundColor: '#b2d6ff',
                    color: '#171717',
                    fontSize: '15',
                    borderRadius: {
                        topLeft: '20',
                        topRight: '20',
                        bottomRight: '20',
                        bottomLeft: '20',
                    },
                    borderColor: '#b2d6ff',
                    hasShadow: true,
                    padding: {
                        top: '9',
                        right: '20',
                        bottom: '9',
                        left: '20',
                    }
                },
                response: {
                    label: {
                        enabled: false,
                        text: 'Alan',
                        color: '#171717',
                        fontSize: '15',
                        icon: {
                            svg: null,
                            gap: '12'
                        },
                        padding: {
                            top: '0',
                            right: '0',
                            bottom: '4',
                            left: '0',
                        },
                        alignment: 'center'
                    },
                    backgroundColor: '#ffffff',
                    codeBackgroundColor: '#f8f8f8',
                    codeTheme: 'light',
                    codeBorderColor: '#DDD',
                    color: '#171717',
                    fontSize: '15',
                    copyBtn: false,
                    likeBtn: false,
                    bottomBtns: {
                        color: '#17171780',
                        backgroundColor: {
                            hover: '#dcddde'
                        },
                    },
                    borderRadius: {
                        topLeft: '20',
                        topRight: '20',
                        bottomRight: '20',
                        bottomLeft: '20',
                    },
                    borderColor: '#ffffff',
                    hasShadow: true,
                    table: {
                        borderColor: '#b7b5b5',
                    },
                    links: {
                        color: {
                            default: '#4183c4',
                            hover: '#4183c4',
                            disable: '#4183c4',
                        }
                    },
                    learnMore: {
                        links: {
                            // gap: string,
                            borderRadius: {
                                topLeft: '4',
                                topRight: '4',
                                bottomRight: '4',
                                bottomLeft: '4',
                            },
                            // padding: IPadding,
                            default: {
                                linkNumberBackgroundColor: '#EAF2FC',
                                backgroundColor: 'transparent',
                                color: '#4183c4',
                                borderColor: '#EAF2FC',
                            },
                            hover: {
                                linkNumberBackgroundColor: '#EAF2FC',
                                backgroundColor: '#EAF2FC',
                                color: '#4183c4',
                                borderColor: '#EAF2FC',
                            },
                            active: {
                                linkNumberBackgroundColor: '#EAF2FC',
                                backgroundColor: '#EAF2FC',
                                color: '#4183c4',
                                borderColor: '#EAF2FC',
                            },
                        }
                    },
                    padding: {
                        top: '9',
                        right: '20',
                        bottom: '9',
                        left: '20',
                    }
                },
                waitingResponse: {
                    queryProgress: {
                        enabled: true
                    },
                    alignment: 'center',
                    layout: 'default',
                    label: DEFAULT_INTERIM_MESSAGE,
                    icon: {
                        svg: null,
                        gap: '8',
                        default: {
                            fill: '#171717'
                        },
                        hover: {
                            fill: '#0078ff'
                        },
                    },
                },
                newDialog: {
                    separator: {
                        color: '#d3dae2'
                    }
                }
            },
            notifications: {
                enabled: true,
                backgroundColor: '#D0021B',
                color: '#ffffff'
            },
            buttons: {
                gap: '8',
                fontSize: '15',
                padding: {
                    top: '9',
                    right: '20',
                    bottom: '9',
                    left: '20',
                },
                borderRadius: {
                    topLeft: '20',
                    topRight: '20',
                    bottomRight: '20',
                    bottomLeft: '20',
                },
                default: {
                    backgroundColor: '#ffffff',
                    color: '#171717',
                    borderColor: '#ffffff',
                    hasShadow: true
                },
                hover: {
                    backgroundColor: '#ffffff',
                    color: '#0078ff',
                    borderColor: '#ffffff',
                    hasShadow: true
                },
                active: {
                    backgroundColor: '#bcdafd',
                    color: '#0078ff',
                    borderColor: '#bcdafd',
                    hasShadow: true
                },
                alignment: {
                    default: 'center',
                    fullScreen: 'center'
                },
                textAlign: {
                    default: 'center',
                    fullScreen: 'center'
                },
            },
        }
    }
} as IAlanButtonOptions;